<template>
<footer class="sitewide-footer relative bg-primary-600">

    <Burn direction="top" start="0%" end="25%" color="bg-primary-600"></Burn>
    
    <section class="footer-bottom px-4 relative z-20 py-5%">

        <div class="max-w-4xl mx-auto">

            <div class="mb-8 flex justify-center">
                <a class="logo inline-block" :href="site.url">
                    <img src="/wp-content/themes/landslide/img/twu-logo.png" alt="Transport Workers Union of America">
                </a>
            </div>

            <div class="flex justify-center items-center mb-12">
                <nav class="flex flex-wrap items-center top-menu">
                    <div v-for="link in topMenu" class="mx-4 relative w-full vt:w-auto text-center">
                        <a class="menu-link airplane-link relative uppercase font-headline font-bold text-white text-xs tracking-wider" :href="link.href">
                            {{ link.name }}
                        </a>
                        <span class="accent absolute text-secondary-500" aria-hidden="true">
                            <i class="fa-solid fa-plane"></i>
                        </span>
                    </div>
                    <SocialLinks :links="site.social_media" class="relative z-10"></SocialLinks>
                </nav>
            </div>

            <div class="flex justify-center mb-8">
                <nav class="bottom-menu flex items-center flex-wrap">
                    <div v-for="link in bottomMenu" class="mx-4 relative w-full vt:w-auto text-center">
                        <Link class="menu-link relative uppercase font-headline font-bold text-white text-xs tracking-wider transition-colors hover:text-secondary-500 focus:text-secondary-500" :href="link.href">
                            {{ link.name }}
                        </Link>
                    </div>
                </nav>
            </div>

            <div class="text-center">
                <p class="text-white text-sm" v-html="footer.data.copyright"></p>
            </div>
            
        </div>

    </section>
</footer>
</template>

<script>
import SocialLinks from './Utilities/SocialLinks.vue';
export default {

    props: {
        context: {
            required: true
        },
        hideForm: {
            default: false
        }
    },

    setup(props) {
        return {
            hideForm: props.context.content.hide_footer_form,
            topMenu: props.context.nav?.footer_menu || [],
            bottomMenu: props.context.nav?.footer_bottom_menu || [],
            ...props.context,
        }
    },

    components: {
        SocialLinks
    }

}
</script>
